"use strict";

require("core-js/modules/es.promise.js");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.string.starts-with.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.array.join.js");

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

var _debug = _interopRequireDefault(require("debug"));

var _config = _interopRequireDefault(require("../config"));

var _ecc = require("../auth/ecc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _apiHost;

var _uiHost;

var _clientId;

var debug = (0, _debug.default)('golos:oauth');

function apiHost() {
  if (_apiHost) return _apiHost;
  var KEY = 'oauth.host';

  var host = _config.default.get(KEY);

  if (!host) throw new Error(KEY + ' is not set in golos.config');
  if (!host.startsWith('http://') && !host.startsWith('https://')) host = 'https://' + host;

  try {
    _apiHost = new URL(host).origin;
  } catch (err) {
    throw new Error(KEY + ' cannot be parsed as URL: ' + host);
  }

  return _apiHost;
}

function uiHost() {
  if (_uiHost) return _uiHost;
  var KEY = 'oauth.ui_host';

  var host = _config.default.get(KEY);

  if (!host) {
    _uiHost = apiHost();
    return _uiHost;
  }

  if (!host.startsWith('http://') && !host.startsWith('https://')) host = 'https://' + host;

  try {
    _uiHost = new URL(host).origin;
  } catch (err) {
    throw new Error(KEY + ' cannot be parsed as URL: ' + host);
  }

  return _uiHost;
}

function clientId() {
  if (_clientId) return _clientId;
  var KEY = 'oauth.client';

  var client = _config.default.get(KEY);

  if (!client) throw new Error(KEY + ' is not set in golos.config');
  _clientId = client;
  return _clientId;
}

function _callApi(url, data) {
  var getHost = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : apiHost;
  var request = {
    method: data ? 'post' : 'get',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-type': data ? 'application/json' : undefined
    },
    body: data ? JSON.stringify(data) : undefined
  };
  return (0, _crossFetch.default)(new URL(url, getHost()), request);
}

function check() {
  return _check.apply(this, arguments);
}

function _check() {
  _check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _callApi('/api/oauth/check/' + clientId());

          case 2:
            res = _context.sent;
            _context.next = 5;
            return res.json();

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _check.apply(this, arguments);
}

function checkReliable() {
  return _checkReliable.apply(this, arguments);
}

function _checkReliable() {
  _checkReliable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var onError,
        retry,
        res,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onError = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : undefined;
            retry = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
            res = null;
            _context2.prev = 3;
            _context2.next = 6;
            return check();

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);

            if (!(onError && onError({
              retry: retry
            }))) {
              _context2.next = 14;
              break;
            }

            throw _context2.t0;

          case 14:
            if (!onError) console.error('oauth.check error:', _context2.t0, 'retrying...');
            setTimeout(function () {
              checkReliable(onError, ++retry);
            }, 3000);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 10]]);
  }));
  return _checkReliable.apply(this, arguments);
}

function waitForLogin(_x, _x2) {
  return _waitForLogin.apply(this, arguments);
}

function _waitForLogin() {
  _waitForLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(onFinish, onFail) {
    var retries,
        onRetry,
        res,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            retries = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 180;
            onRetry = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : undefined;

            if (retries) {
              _context3.next = 6;
              break;
            }

            console.error('waiting for login is timeouted');
            onFail();
            return _context3.abrupt("return");

          case 6:
            _context3.next = 8;
            return checkReliable();

          case 8:
            res = _context3.sent;

            if (!res.authorized) {
              _context3.next = 13;
              break;
            }

            onFinish(res);
            _context3.next = 18;
            break;

          case 13:
            if (!(onRetry && onRetry({
              retriesLeft: retries
            }))) {
              _context3.next = 16;
              break;
            }

            onFail();
            return _context3.abrupt("return");

          case 16:
            debug('waiting for login...');
            setTimeout(function () {
              waitForLogin(onFinish, onFail, --retries, onRetry);
            }, 1000);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _waitForLogin.apply(this, arguments);
}

function login() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof window === 'undefined') {
    throw new Error('OAuth works only in browser environment (window should be defined)');
  }

  return window.open(uiHost() + '/oauth/' + clientId() + '/' + permissions.join(',') + extraParams);
}

function logout() {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _callApi('/api/oauth/logout/' + clientId());

          case 2:
            res = _context4.sent;

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _logout.apply(this, arguments);
}

function _hashOps(operations) {
  var json = JSON.stringify(operations);

  var idHash = _ecc.hash.sha256(json, 'hex');

  return idHash;
}

module.exports = {
  clientId: clientId,
  apiHost: apiHost,
  uiHost: uiHost,
  _callApi: _callApi,
  check: check,
  checkReliable: checkReliable,
  login: login,
  waitForLogin: waitForLogin,
  logout: logout,
  _hashOps: _hashOps
};